module.exports = __webpack_public_path__ + "ortved_square-d5b2ddc652e5fb08cf0d70e6e2a89d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/ortved_square.jpg
// module id = 1168
// module chunks = 1 2